import TareasComponent from '@/components/tareas/TareasComponent'

export default []